import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IBatch, MesBatchService } from '../mes-batch-service';

@Component({
	selector: 'app-delete-batch',
	templateUrl: './delete-batch.component.html',
	styleUrls: ['./delete-batch.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class DeleteBatchComponent {
	@Output() deleted: EventEmitter<any> = new EventEmitter();
	httpError: string = '';
	loading: boolean | null;

	constructor(
		@Inject(MAT_DIALOG_DATA) public item: IBatch,
		public dialogRef: MatDialogRef<DeleteBatchComponent>,
		private service: MesBatchService,
	) {}

	onCancel = () => this.dialogRef.close();

	async onDelete() {
		if (this.loading) return;
		this.loading = true;
		this.httpError = '';
		this.service.deleteById(this.item.id).subscribe({
			next: () => {
				this.deleted.emit();
				this.dialogRef.close();
			},
			error: (errorResponse) => {
				this.httpError = `${errorResponse.status}`;
				this.loading = false;
			},
		});
	}
}
